import React, { FC, MouseEvent, useEffect } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';

import { ymPushParams } from 'utils/ym';

import type { TBuyModalContent } from '../../types';
import { ChooseSimTypeItem } from './ChooseSimTypeItem';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

type TChooseSimType = {
  esimHref?: string;
  isDisabled?: boolean;
  onClickESim: (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  onClickSim: () => void;
  title: string;
  variants: TBuyModalContent['variants'];
};

const getModalAnalyticsProps = (title: string) => {
  const pagePath = typeof window !== 'undefined' ? window.location.pathname : '';
  const pageUrl = typeof window !== 'undefined' ? window.location.href : '';
  const pageTitle = typeof window !== 'undefined' ? document.title : '';
  return {
    tariff_catalog_mobile: {
      page_url: pageUrl,
      page_path: pagePath,
      page_title: pageTitle,
      account_type: 'none',
      action: 'view',
      item_type: 'popup',
      popup_title: title,
    },
  };
};

// Выбор варианта покупки sim/esim
export const ChooseSimType: FC<TChooseSimType> = ({
  variants,
  title,
  onClickSim,
  onClickESim,
  isDisabled,
  esimHref,
}) => {
  useEffect(() => {
    /* Отправка аналитики при видимости модалки */
    ymPushParams(getModalAnalyticsProps(title));
  }, []);

  return (
    <>
      <Text className={cx('modal-title')} variant="display-small">
        {title}
      </Text>
      <div className={cx('container', { 'is-disabled': isDisabled })}>
        <ChooseSimTypeItem {...variants.sim} onClick={onClickSim} />
        <ChooseSimTypeItem {...variants.eSim} href={esimHref} onClick={onClickESim} />
      </div>
    </>
  );
};
